/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.presentationModule')
  .controller('PresentationFooterController', ['BulbPresentationService', 'BulbUnitService', PresentationFooterController]);

/**
 * AngularJS controller for footer of a presentation page view.
 */
function PresentationFooterController(BulbPresentationService, BulbUnitService) {
  this.unit = BulbUnitService.currentUnit;

  BulbPresentationService.fetchUnits();

  /**
   * exit full screen.
   */
  this.exit = function () {
    BulbPresentationService.exitPresentation(false);
  };

  this.goToPrevious = function () {
    BulbPresentationService.firstTimePresenting = false;
    BulbPresentationService.changePage(BulbPresentationService.previousUnit);
  };

  this.goToNext = function () {
    BulbPresentationService.firstTimePresenting = false;
    BulbPresentationService.changePage(BulbPresentationService.nextUnit);
  };

  // This method is not used now, but left for future use.
  this.toggleUsePublishedVersion = function () {
    BulbPresentationService.usePublishedVersion = !BulbPresentationService.usePublishedVersion;
    if (this.unit.unitType !== 'PublishedPageUnit' && !this.unit.isPublished) {
      return;
    }
    BulbPresentationService.changePage(this.unit);
  };

  this.pageFilter = function (unit) {
    if (unit.unitType === 'CompositeUnit') {
      return false;
    }
    return true;
  };

  this.consumeEvent = function (event) {
    event.stopPropagation();
  };

  this.showNextOrPreviousButton = function (unit) {
    return (unit.unitType !== 'CompositeUnit'
      && unit.id);
  };

  {
    BulbPresentationService.saveLastState(this.unit);
  }
}
